const BaseApiState = {
  isLoading: false,
  success: false,
  payload: null,
  error: null,
  message: null
};
export interface createBaseAPi {
  isLoading: boolean,
  success: boolean,
  payload: any,
  error: any,
  message?: string
}


export default BaseApiState;


